// DS: C25A
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useContext } from 'react';
import FolderDropdownDesktop from './FolderDropdownDesktop';
import FolderDropdownMobileV3 from './FolderDropdownMobileV3';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
const FolderDropdown = (props)=>{
    const isMobile = useContext(MobileContext);
    const invisible_folders = useFlag('invisible_folders');
    if (isMobile) {
        return /*#__PURE__*/ React.createElement(FolderDropdownMobileV3, _object_spread_props(_object_spread({}, props), {
            filterEmpty: !invisible_folders
        }));
    }
    return /*#__PURE__*/ React.createElement(FolderDropdownDesktop, _object_spread_props(_object_spread({}, props), {
        filterEmpty: !invisible_folders
    }));
};
export default FolderDropdown;
